<template>
  <div id="confirm-add-document-modal">
    <div class="modal-body">
      <b-container fluid>
        <b-row>
          <b-col cols="5">
            <h5 class="text-left">
              {{ hospital }}
            </h5>
          </b-col>
          <b-col
            offset="2"
            cols="5"
            class="text-right"
          >
            <b-row>
              <b-col class="mt-1">
                วันที่ออกเอกสาร
              </b-col>
              <b-col>
                <b-form-input
                  :value="dateInvoice"
                  :disabled="true"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="10">
            <b-row>
              <b-col
                v-for="(documentType, index) in numberList"
                :key="index"
                cols="6"
              >
                <b-row>
                  <b-col>
                    <label
                      :for="`number-${documentType.id}`"
                    >เลขที่{{
                      documentType.document
                    }}</label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      v-model="numberList[index].number"
                      @change="changeNumber"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <confirm-add-document-table-modal
            v-if="corporationType ==='corporation'"
            class="table-modal"
            :orders="orders"
          />
          <confirm-add-other-platform-document-table-modal
            v-else
            class="table-modal"
            :orders="orders"
          />
        </b-row>
        <b-row>
          <b-col
            cols="12"
            class="p-0"
          >
            <add-document-footer :data="orders" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmAddDocumentTableModal from "../../components/Account/ConfirmAddDocumentTableModal";
import ConfirmAddOtherPlatformDocumentTableModal from "../../components/Account/ConfirmAddOtherPlatformDocumentTableModal"
import AddDocumentFooter from "../../components/Account/AddDocumentFooter"

export default {
    name: "ConfirmAddDocumentModal",
    components: {
        ConfirmAddDocumentTableModal,
        AddDocumentFooter,
        ConfirmAddOtherPlatformDocumentTableModal
    },
    props: {
        dateInvoice: {},
        invoiceNumber: {
            type: String
        },
        orders: {
            type: Array
        },
        hospital: {
            type: String
        },
        numbers: {
            type: Array
        },
        submit: {
            type: Function
        },
        close: {
            type: Function
        },
        corporationType: {
            type: String
        }
    },
    computed: {
        ...mapGetters({
            documentTypes: "Account/getFilterDocumentType"
        })
    },
    created() {
        for (let documentType of this.documentTypes) {
            if (documentType.has_number) {
                this.numberList.push({
                    number: this.invoiceNumber,
                    document: documentType.name,
                    document_id: documentType.id
                });
            }
        }
        this.$emit("update:numbers", this.numberList);
    },
    data() {
        return {
            numberList: []
        };
    },
    methods: {
        changeNumber() {
            this.$emit("update:numbers", this.numberList);
        }
    }
};
</script>

<style lang="scss" scoped>
.table-modal {
    /*max-height: 400px;*/
    overflow-y: auto;
}
</style>
